module.exports = __webpack_public_path__ + "img/msk.4f4efef4.jpg";